import React from 'react';
import { Router } from '../../pages/Router';


export const Content = (): React.ReactElement => {
  return <div className="h-full flex-1 bg-layout-secondary overflow-scroll pb-16" id="main-content">
    <div className="p-7 flex justify-center flex-col">
      <Router />
    </div>
  </div>
}
